import React from "react";
import { useCurrency } from "../lib/currency";
import { ChevronDown } from "lucide-react";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "./ui/dropdown-menu";

export const CurrencySelector = () => {
    const { currency, setCurrency, currencies } = useCurrency();
    const current = currencies[currency];

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button
                    data-testid="currency-selector"
                    className="flex items-center gap-1.5 border border-soft px-2.5 py-1.5 text-xs font-semibold hover:border-amber"
                    style={{ color: "var(--amber)" }}
                >
                    <span className="text-base leading-none">{current.symbol}</span>
                    <span>{current.code}</span>
                    <ChevronDown size={12} />
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
                align="end"
                className="bg-elev border-strong"
                style={{ background: "var(--bg-elev)", borderColor: "var(--border-strong)" }}
            >
                {Object.entries(currencies).map(([code, info]) => (
                    <DropdownMenuItem
                        key={code}
                        data-testid={`currency-${code}`}
                        onClick={() => setCurrency(code)}
                        className={`cursor-pointer text-xs ${currency === code ? "text-amber" : ""}`}
                        style={currency === code ? { color: "var(--amber)" } : undefined}
                    >
                        <span className="w-6 text-base">{info.symbol}</span>
                        <span className="font-semibold mr-2">{info.code}</span>
                        <span className="text-dim">{info.label}</span>
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
